import { render } from "./RugbyTeamInsights.vue?vue&type=template&id=40a7374c&scoped=true"
import script from "./RugbyTeamInsights.vue?vue&type=script&lang=js"
export * from "./RugbyTeamInsights.vue?vue&type=script&lang=js"

import "./RugbyTeamInsights.vue?vue&type=style&index=0&id=40a7374c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a7374c"]])

export default __exports__